export default function isSafari() {
  return (
    window.navigator.userAgent.includes('Safari') && !window.navigator.userAgent.includes('Chrome') && !window.navigator.userAgent.includes('FxiOS')
  );
}
